import {BarraEvento,EspacioEventos,SeccionPanel} from './pages/roles/NavegacionPanel';
import AdminConsumo from './pages/barra/AdminConsumo';
import Barra from './pages/barra/Barra';
import ConsumoBarra from './pages/barra/ConsumoBarra';
import GestionComisiones from './pages/actividad/GestionComisiones';
import './styles/panelesMoviles.css';
import HistorialAuditoria from './pages/actividad/HistorialAuditoria';
import RolesPermisos from './pages/roles/RolesPermisos';
import ConfigurarEvento from './pages/eventos/ConfigurarEvento';
import MiActividad from './pages/actividad/MiActividad';
import {lazy as lazyRecinto,Suspense as RecintoSuspense} from 'react';
import React from 'react';
// src/App.js
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Pendiente from "./pages/Pendiente";
import GenerarInvitacionesUnificado from "./pages/invitaciones/GenerarInvitacionesUnificado";
import VistaInvitacion from "./pages/invitaciones/VistaInvitacion";
import VistaInvitacionEscaner from "./pages/invitaciones/VistaInvitacionEscaner";
import CalibrarInvitacion from "./pages/invitaciones/CalibrarInvitacion";
import Owner from "./pages/roles/Owner";
import Socio from "./pages/roles/Socio";
import Imagen from "./pages/roles/Imagen";
import Rrpp from "./pages/roles/Rrpp";
import Comisiones from "./pages/roles/Comisiones";
import GestionPersonal from "./pages/roles/GestionPersonal";
import Administracion from "./pages/roles/Administracion";
import Organizador from "./pages/roles/Organizador";
import PorteriaDashboard from "./pages/roles/PorteriaDashboard";
import Reservas from "./pages/reservas/Reservas";
import AdminReservas from "./pages/reservas/AdminReservas";
import PanelInvitaciones from "./pages/admin/PanelInvitaciones";
import Promotores from "./pages/admin/Promotores";
import GenerarEntradas from "./pages/entradas/GenerarEntradas";
import AdminEntradas from "./pages/entradas/AdminEntradas";
import EscanearEntradas from "./pages/entradas/EscanearEntradas";
import CalibrarEntrada from "./pages/entradas/CalibrarEntrada";
import Eventos from "./pages/eventos/Eventos";
import Empresas from "./pages/empresas/Empresas";
import ConfigurarCombos from "./pages/eventos/ConfigurarCombos";
import ConfigurarPaquetesReserva from "./pages/eventos/ConfigurarPaquetesReserva";
import SinAcceso from "./pages/system/SinAcceso";
import Protected from "./auth/Protected";
import EventPermission from "./auth/EventPermission";
import EventSelector from "./components/EventSelector";
import ReservasAdminLayout from "./pages/admin/reservas/ReservasAdminLayout";
import PaquetesReserva from "./pages/admin/reservas/PaquetesReserva";
import ListasReserva from "./pages/admin/reservas/ListasReserva";
import AsignarListaEvento from "./pages/admin/reservas/AsignarListaEvento";
import ScanQR from "./pages/ScanQR";

import './styles/temaPalmarama.css';

const EditorRecintos3D=lazyRecinto(()=>import('./pages/recintos/EditorRecintos'));
const OWNER = ["owner"];
const OWNER_SOCIO = ["owner", "socio"];
const ADMIN_EVENTOS = ["owner", "socio", "organizador"];
const REPORTES = ["owner", "socio", "organizador", "administracion"];
const RESERVAS = ["owner", "socio", "rrpp", "imagen", "organizador"];
const ESCANER = ["owner", "socio", "organizador", "porteria"];
const AUTHED = ["owner", "socio", "organizador", "administracion", "imagen", "rrpp", "porteria", "barra"];

function secure(element, roles = AUTHED, permiso = null, capacidad=null) {
  return <Protected roles={roles} capacidad={capacidad}>{permiso ? <EventPermission permiso={permiso}>{element}</EventPermission> : element}</Protected>;
}


function LegacyInvitationEventRedirect() {
  const { codigo } = useParams();
  return <Navigate to={`/invitacion/${encodeURIComponent(codigo || "")}`} replace />;
}

function App() {
  return (
    <Router><BarraEvento/><Routes>
      <Route path="/trabajo/eventos" element={secure(<EspacioEventos/>)} />
      <Route path="/trabajo/eventos/:eventoId" element={secure(<EspacioEventos/>)} />
      <Route path="/trabajo/administracion" element={secure(<SeccionPanel grupo="administracion"/>)} />
      <Route path="/trabajo/sistema" element={secure(<SeccionPanel grupo="sistema"/>)} />
      <Route path="/trabajo/escaneres" element={secure(<SeccionPanel grupo="escaneres"/>)} />
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route path="/register" element={<Register />} />
      <Route path="/pendiente" element={<Pendiente />} />
      <Route path="/sin-acceso" element={<SinAcceso />} />

      <Route path="/dashboard" element={secure(<Dashboard />)} />
      <Route path="/dashboard/gestion-personal" element={secure(<GestionPersonal />, OWNER,null,"usuarios.gestionar")} />
      <Route path="/dashboard/planimetria" element={secure(<Navigate to="/dashboard/reservas" replace />)} />
      <Route path="/dashboard/configuracion" element={secure(<Navigate to="/admin/reservas" replace />, OWNER,null,"paquetes.gestionar")} />

      <Route path="/admin/generar-invitaciones" element={secure(<EventSelector modo="generarInvitaciones" />, [...ADMIN_EVENTOS,"imagen"],null,"invitaciones.generar")} />
      <Route path="/dashboard/invitaciones" element={secure(<EventSelector modo="generarInvitaciones" />, [...ADMIN_EVENTOS,"imagen"],null,"invitaciones.generar")} />
      <Route path="/admin/invitaciones" element={secure(<EventSelector modo="administrarInvitaciones" />, REPORTES,null,"invitaciones.ver")} />
      <Route path="/admin/invitaciones/:eventoId" element={secure(<PanelInvitaciones />, REPORTES, "reportes","invitaciones.ver")} />
      <Route path="/invitaciones/generar/:eventoId" element={secure(<GenerarInvitacionesUnificado />, [...ADMIN_EVENTOS,"imagen"], "invitaciones","invitaciones.generar")} />

      <Route path="/entradas" element={secure(<EventSelector modo="generarEntradas" />, ADMIN_EVENTOS,null,"entradas.vender")} />
      <Route path="/admin/generar-entradas" element={secure(<Navigate to="/entradas" replace />, ADMIN_EVENTOS)} />
      <Route path="/entradas/admin" element={secure(<EventSelector modo="administrarEntradas" />, REPORTES,null,"entradas.ver")} />
      <Route path="/admin/entradas" element={secure(<Navigate to="/entradas/admin" replace />, REPORTES)} />
      <Route path="/entradas/generar/:eventoId" element={secure(<GenerarEntradas />, ADMIN_EVENTOS, "entradas","entradas.vender")} />
      <Route path="/entradas/admin/:eventoId" element={secure(<AdminEntradas />, REPORTES, "reportes","entradas.ver")} />

      <Route path="/dashboard/reservas" element={secure(<EventSelector modo="reservas" />, RESERVAS,null,"reservas.ver")} />
      <Route path="/dashboard/reservas/evento/:eventoId" element={secure(<Reservas />, RESERVAS, "reservas","reservas.ver")} />
      <Route path="/dashboard/rrpp/reservas" element={<Navigate to="/dashboard/reservas" replace />} />
      <Route path="/dashboard/rrpp/reservas/evento/:eventoId" element={secure(<Reservas />, ["owner", "socio", "rrpp", "imagen"], "reservas")} />
      <Route path="/admin/reservas-panel" element={secure(<AdminReservas />, ["owner", "socio", "administracion"],null,"reservas.ver")} />
      <Route path="/admin/reservas" element={secure(<ReservasAdminLayout />, OWNER,null,"paquetes.gestionar")}>
        <Route index element={<PaquetesReserva />} />
        <Route path="paquetes" element={<Navigate to="/admin/reservas" replace />} />
        <Route path="listas" element={<ListasReserva />} />
        <Route path="eventos" element={<AsignarListaEvento />} />
      </Route>

      <Route path="/eventos/configurar/:eventoId" element={secure(<ConfigurarEvento />, OWNER,null,"eventos.gestionar")} />
      <Route path="/eventos" element={secure(<Eventos />, ADMIN_EVENTOS,null,'eventos.ver')} />
      <Route path="/empresas" element={secure(<Empresas />, ADMIN_EVENTOS,null,'empresas.ver')} />
      <Route path="/admin/eventos/:eventoId/combos" element={secure(<ConfigurarCombos />, OWNER_SOCIO, "entradas")} />
      <Route path="/admin/eventos/:eventoId/reservas-paquetes" element={secure(<ConfigurarPaquetesReserva />, OWNER,null,"paquetes.gestionar")} />
      <Route path="/admin/eventos/:eventoId/calibrar" element={secure(<CalibrarInvitacion />, OWNER,null,"eventos.gestionar")} />
      <Route path="/admin/eventos/:eventoId/calibrar-entrada" element={secure(<CalibrarEntrada />, OWNER,null,"eventos.gestionar")} />

      <Route path="/admin/roles" element={secure(<RolesPermisos/>,OWNER)} />
      <Route path="/admin/historial" element={secure(<HistorialAuditoria/>)} />
      <Route path="/admin/recintos" element={secure(<RecintoSuspense fallback={<p>Cargando estudio 3D…</p>}><EditorRecintos3D/></RecintoSuspense>, OWNER,null,"recintos.gestionar")} />
      <Route path="/dashboard/owner" element={secure(<Owner />, OWNER)} />
      <Route path="/dashboard/socio" element={secure(<Socio />, OWNER_SOCIO)} />
      <Route path="/dashboard/organizador" element={secure(<Organizador />, ["owner", "socio", "organizador"])} />
      <Route path="/dashboard/administracion" element={secure(<Administracion />, ["owner", "socio", "administracion"])} />
      <Route path="/dashboard/imagen" element={secure(<Imagen />, ["owner", "socio", "imagen"])} />
      <Route path="/dashboard/rrpp" element={secure(<Rrpp />, ["owner", "socio", "rrpp"])} />
      <Route path="/admin/comisiones" element={secure(<GestionComisiones />, OWNER,null,'comisiones.gestionar')} />
      <Route path="/dashboard/actividad" element={secure(<MiActividad />, RESERVAS,null,'actividad.ver')} />
      <Route path="/dashboard/comisiones" element={secure(<Comisiones />, RESERVAS,null,'actividad.ver')} />
      <Route path="/dashboard/rrpp/comisiones" element={secure(<Comisiones />, RESERVAS,null,'actividad.ver')} />
      <Route path="/admin/consumo" element={secure(<AdminConsumo/>, AUTHED,null,"consumo.administrar")} />
      <Route path="/dashboard/barra" element={secure(<Barra/>, ["owner","barra"])} />
      <Route path="/barra/escanear" element={secure(<ConsumoBarra/>, AUTHED,null,"consumo.escanear")} />
      <Route path="/barra/entregas" element={secure(<ConsumoBarra historial/>, AUTHED,null,"consumo.entregas")} />
      <Route path="/dashboard/porteria" element={secure(<PorteriaDashboard />, ["owner", "socio", "porteria"])} />

      <Route path="/invitaciones/crear" element={secure(<Navigate to="/dashboard/invitaciones" replace />, ADMIN_EVENTOS)} />
      <Route path="/invitacion/:codigo" element={<VistaInvitacion />} />
      <Route path="/invitacion-evento/:eventoId/:codigo" element={<LegacyInvitationEventRedirect />} />
      <Route path="/escanear/:codigo" element={secure(<VistaInvitacionEscaner />, ESCANER,null,'escaner.invitaciones')} />
      <Route path="/escanear" element={secure(<ScanQR />, ESCANER,null,'escaner.invitaciones')} />
      <Route path="/entradas/escanear" element={secure(<EscanearEntradas />, ESCANER,null,'escaner.entradas')} />

      <Route path="/admin/corregir-invitaciones" element={secure(<Navigate to="/admin/invitaciones" replace />, OWNER)} />
      <Route path="/admin/migrar" element={secure(<Navigate to="/admin/invitaciones" replace />, OWNER)} />
      <Route path="/admin/promotores" element={secure(<Promotores />, OWNER,null,"usuarios.gestionar")} />
      <Route path="/agregar-reserva" element={secure(<Navigate to="/dashboard/reservas" replace />, RESERVAS)} />
      <Route path="/entrada/:id" element={<VistaInvitacion />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes></Router>
  );
}
export default App;
